module.exports = __webpack_public_path__ + "src/assets/img/logo_topclass_blanco_icono.517d0a8a.svg";